module.exports = __webpack_public_path__ + "static/media/22f25bfe-3df1-4336-977c-245a2cf207f5.c9e9897f.JPG";